<template>
    <div>
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="vehicleFreePlatform"
            :currentPage="currentPage"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @searchChange="searchChange"
            @edit-btn="editBtn">
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" reportCode="ET_TRANSIT_TRACKING_QUERY">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'05020002'">
                            <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
        </m-pane>
        <el-dialog
            title="编辑"
            :visible.sync="visible"
            width="80%"
            @close="handleClose">
            <el-form
                ref="form"
                inline
                :model="ruleForm"
                label-position="right"
                label-width="100px"
                :rules="rules">
                <el-row :gutter="10">
                    <el-col :span="6">
                        <el-form-item label="跟进人" prop="ettgFollow">
                            <el-input v-model="ruleForm.ettgFollow" :disabled="+ruleForm.ettgFollowStatus === 1" style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="跟进人电话" prop="ettgFollowMobile">
                            <el-input v-model="ruleForm.ettgFollowMobile" :disabled="+ruleForm.ettgFollowStatus === 1" style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="跟进内容" prop="ettgFollowRemark">
                            <el-input v-model="ruleForm.ettgFollowRemark" :disabled="+ruleForm.ettgFollowStatus === 1" style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => {this.handleClose()}">取 消</el-button>
                <el-button type="primary" @click="handleChange('close')" :loading="closeLoading">关 闭</el-button>
                <el-button type="primary" @click="handleChange('save')" :loading="saveLoading">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import mPane from '@/components/supplierPanel';
import config from './config.js';
import { getWarningList, saveTransitTracking } from '../../../api/passage';
import { maxDay } from '@/modules/transport/tms/common/common';
import dayjs from 'dayjs';
import reportExport from '@/components/lots/reportExportPlugin';
import common from '../../../common/common';
import { mapGetters } from 'vuex';
const { getSessionKey, initSessionData } = common;
export default {
    components: { mPane, reportExport },
    mounted() {
        initSessionData(['SYS_TMS_ABNORMAL_TYPE']);
        // this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    computed: {
        ...mapGetters(['supplier', 'currentTenant'])
    },
    data() {
        return {
            config,
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页数量
            searchData: {}, // 搜索的对象结果
            visible: false, // 弹窗
            saveLoading: false, // 保存loading
            closeLoading: false, // 关闭loading
            isFirstSearch: true,
            exportParams: {},
            ruleForm: {
                ettgFollow: '',
                ettgFollowMobile: '',
                ettgFollowRemark: ''
            },
            rules: {
                ettgFollow: [
                    { required: true, message: '请选择站点', trigger: 'change' }
                ],
                ettgFollowMobile: [
                    { required: true, message: '请选择站点', trigger: 'change' }
                ],
                ettgFollowRemark: [
                    { required: true, message: '请选择站点', trigger: 'change' }
                ]
            }
        };
    },
    methods: {
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (!this.isFirstSearch) {
                const msg = this._validateSearchParams(this.searchData);
                if (msg) return this.$message.warning(msg);
            }
            submit({ ...this.exportParams, carrierCode: this.supplier.supplierCode, tenantCode: this.currentTenant.tenantCode });
            this.isFirstSearch = false;
        },
        _validateSearchParams(data) {
            if (!data.createTimeFrom) {
                return '创建日期不能为空！';
            }
            const beginDate = dayjs(data.createTimeFrom).valueOf() || 0;
            const endDate = dayjs(data.createTimeTo).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            if (differenceValue > maxDay) {
                return '按时间查询或导出时，时间跨度不可超过一个月！';
            }
        },
        _getList(pageNo = 1) {
            const msg = this._validateSearchParams(this.searchData);
            if (msg) return this.$message.warning(msg);
            this.exportParams = {
                ...this.searchData,
                etdoCarrierCode: this.supplier.supplierCode
            };
            this.loading = true;
            const {
                SYS_TMS_ABNORMAL_TYPE,
                SYS_YES_NO
            } = sessionStorage;
            getWarningList({
                pageNo,
                pageSize: this.pageSize,
                etdoCarrierCode: this.supplier.supplierCode,
                ...this.searchData
            }).then((res) => {
                if (res && res.data && +res.code === 0) {
                    const { list, totalCount, pageNo } = res.data;
                    this.totalData = list.map(item => {
                        // 异常类型
                        item.ettgAbnormalClassType = getSessionKey(item.ettgAbnormalClass, SYS_TMS_ABNORMAL_TYPE);
                        // 是否关闭
                        item.ettgFollowStatusType = getSessionKey(item.ettgFollowStatus, SYS_YES_NO);
                        return item;
                    });
                    this.pageTotal = totalCount;
                    this.currentPage = +pageNo;
                }
                this.loading = false;
            });
        },
        // 编辑保存
        _saveTransitTracking(test) {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.$message.error('请正确填写表单!');
                    return false;
                } else {
                    if (test === 'save') {
                        this.saveLoading = true;
                    }
                    if (test === 'close') {
                        this.ruleForm.ettgFollowStatus = '1';
                        this.closeLoading = true;
                    }
                    saveTransitTracking(this.ruleForm).then(res => {
                        if (res) {
                            if (res.data.success) {
                                this.$message.success('成功!');
                                this.handleClose(true);
                            } else {
                                this.$message.error(res.data.messagesAsString);
                            }
                        }
                        this.closeLoading = false;
                        this.saveLoading = false;
                    });
                }
            });
        },
        pageChange(val) {
            this.currentPage = val;
            this._getList(val);
        },
        sizeChange(val) {
            this.pageSize = val;
            this._getList();
        },
        // 查询结果
        searchChange(val) {
            val = this.formattingData(val);
            this.searchData = val;
            this._getList();
        },
        formattingData(data) {
            const tempData = {
                createTimeFrom: data.createTime && data.createTime.length ? dayjs(data.createTime[0]).format('YYYY-MM-DD HH:mm') : '',
                createTimeTo: data.createTime && data.createTime.length ? dayjs(data.createTime[1]).format('YYYY-MM-DD HH:mm') : '',
                ...data
            };
            delete tempData.createTime;
            return tempData;
        },
        editBtn(row) {
            this.ruleForm = Object.assign({}, this.ruleForm, row);
            this.visible = true;
        },
        handleClose(req) {
            this.ruleForm = {
                ettgFollow: '',
                ettgFollowMobile: '',
                ettgFollowRemark: ''
            };
            this.visible = false;
            this.$refs.form.resetFields();
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleChange(test) {
            this._saveTransitTracking(test);
        }
    }
};
</script>
<style lang="less">
</style>